export const layoutTypes = {
  LOADING: 'LOADING',
  LOADING_TABLE: 'LOADING_TABLE',
  LOADING_UPDATE_USER: 'LOADING_UPDATE_USER',
  IS_MOBILE: 'IS_MOBILE',
};
